import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsHeatmap from "highcharts/modules/heatmap";
import HighchartsTilemap from 'highcharts/modules/tilemap';
import PropTypes from 'prop-types';
import React from 'react';
import { COLORS } from '../../../config/colors';

HighchartsHeatmap(Highcharts);
HighchartsTilemap(Highcharts);

Highcharts.setOptions({
  colors: [COLORS.PINK, COLORS.PURPLE, COLORS.BLUE, COLORS.ORANGE, COLORS.RED, COLORS.YELLOW]
});
/**
 *
 * @param {*} data
 * @param {*} title
 * @param {*} limit
 * @returns {Highcharts.Options}
 */
export const createHoneycombChart = (data, title, options) => ({
  title: {
    text: title,
    style: {
      fontSize: '1em'
    }
  },
  xAxis: {
    visible: false
  },

  yAxis: {
    visible: false
  },
  series: [{
    name: '',
    data
  }],
  chart: {
    type: 'tilemap',
    inverted: true,
    spacing: [0, 0, 0, 0],
  },
  credits: {
    enabled: false
  },
  ...options,
});

const Honeycomb = ({
  data,
  title,
  options
}) => {
  const chartsOptions = createHoneycombChart(data, title, options);

  return (
    <figure className="highcharts-figure">
      <HighchartsReact
        highcharts={Highcharts}
        options={chartsOptions}
      />
    </figure>
  );
};

Honeycomb.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number,
      value: PropTypes.number
    })
  ).isRequired,
  title: PropTypes.string,
  options: PropTypes.object
};

Honeycomb.defaultProps = {
  options: {},
  title: null
};
export default Honeycomb;